<template>
  <div class="PCHomeTab2">
    <vue-lazy-component tagName="div" :timeout="2000">
      <!-- <YourFamilyCompanion /> -->
      <div class="title-text-box">
        <div class="describe">
          Wherever and whenever you may be, the EBO HOME App allows you to monitor your home, your family, 
          and your companions. Nowhere is warmer than home, and nothing is more precious than family. With EBO X, you are home.
        </div>
      </div>
      <EboHomeApp />
      <RealTimeTwoWay />
    </vue-lazy-component>
    <vue-lazy-component tagName="div" :timeout="4000">
      <LeavingVoiceMessage />
      <MultipleLogin />
      <ColorNightVision />
    </vue-lazy-component>
    <vue-lazy-component tagName="div" :timeout="6000">
      <SoundSourceLocation />
      <SmartTracking />
      <SmartPersonalAssistant />
      <ThePerfectPetCompanion />
    </vue-lazy-component>
  </div>
</template>

<script>


import EboHomeApp from './eboHomeApp'
// import YourFamilyCompanion from './yourFamilyCompanion'
import RealTimeTwoWay from './realTimeTwoWay'
import LeavingVoiceMessage from './leavingVoiceMessage'
import MultipleLogin from './multipleLogin'
import ColorNightVision from './colorNightVision'
import SoundSourceLocation from './soundSourceLocation'
import SmartTracking from './smartTracking'
import SmartPersonalAssistant from './smartPersonalAssistant'
import ThePerfectPetCompanion from './thePerfectPetCompanion'


export default {
  components:{
    EboHomeApp,
    // YourFamilyCompanion,
    RealTimeTwoWay,
    LeavingVoiceMessage,
    MultipleLogin,
    ColorNightVision,
    SoundSourceLocation,
    SmartTracking,
    SmartPersonalAssistant,
    ThePerfectPetCompanion,
  }
}
</script>

<style lang="scss">
  .PCHomeTab2{
    // padding-bottom: 120px;
    width: 100%;
    margin: 0 auto;
    background: RGBA(4, 13, 50, 1);
    .title-text-box {
      width: 715px;
      margin: 0 auto;
      margin-bottom: 118px;
      // margin-top: 100px;

      .describe {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
      }

    }
  }
</style>